import React from 'react'

import EditableInput from "./input-component"
import FieldProto from "../../../../proto/field-proto";
import {toggleClass} from "../../../../../gd/utils/dom-and-react/react-utils"
import {FieldInlineEditableProps} from "../../../../render/inline-editable";
import {FieldViewSize} from "../../../../const";

type Props = {
    field               : FieldProto
    value               : any // string or number

    className?          : string
    inputClassName?     : string
    viewClasses?        : string
    editClasses?        : string

    disabled?           : boolean
    isNumber?           : boolean   // set to true if this is a number / currency

    onChange?           : callback
    onImmediateChange?  : callback

    // Experimental Vic
    onEnter?            : callback
    options?            : any
    // autoSaveChanges?    : boolean   // I think this no use
    // end experimental
} & FieldInlineEditableProps


export default class FieldString_RenderEditableInlineInput extends React.Component<Props,any> {

    public value        : any
    public renderState  : any
    public input        : any
    public _switchToViewOnNextChange    : boolean   = false

    static defaultProps = {
        viewClasses     : "ui5-txt-default ui5-field-input-hover-border w-300 h-36 p-l-10 p-r-10",
        editClasses     : "ui5-txt-default ui5-field-form-editable w-300 h-36 p-l-10 p-r-10",
        isNumber        : false,
        disabled        : false
    }

    constructor(props:any) {
        super(props);

        this.value          = this.props.value

        this.renderState    = 'view'

        if (this.props.options?.autofocus) {
            this.renderState = 'edit'
        }
    }

    UNSAFE_componentWillReceiveProps(nextProps:any, nextContext:any) {
        if (this.value !== nextProps.value) {
            this.value = nextProps.value;
        }
    }

    isValueValid(value?:string) {
        return this.props.field.isValueValid(value || this.value)
    }

    onClick = (e?:React.SyntheticEvent) => {
        if(e) e.stopPropagation();

        if (this.props.disabled) return

        this.renderState = 'edit';
        this.forceUpdate(()=>this.input.focus())
    }

    onBlur = () => {
        this._switchToViewOnNextChange = true;
    }

    onImmediateChange = (value:any) => {
        this.props.onImmediateChange && this.props.onImmediateChange(value)

        toggleClass(this.input, 'invalid-value', !this.isValueValid(value))
    }

    // bind is used for overwrite to work !!!
    onChange(value:any) { // dont change
        this.value = value;
        this.renderState = this._switchToViewOnNextChange ? 'view' : 'edit';

        this.forceUpdate(()=>{
            if (this.props.onChange) this.props.onChange(value)
        })
    }

    // The classes this input renders at its current size.
    //
    // FieldViewSize.SMALL returns its own set rather than adding to the default one - the two
    // disagree on font, height and padding, and mixing them would leave the winner up to the
    // order the stylesheet happens to declare them in. Its numbers follow what
    // .ui5-field-editable calls size-small in fields/field-editable.scss (30px tall, 8px of
    // side padding, small text), because the older ui5-field-input-hover-border and
    // ui5-field-form-editable classes this input is built on carry no size rules of their own.
    // w-300 goes with them: at this size the input sits in a table or a list, which sets the width.
    //
    // GOTCHA - a caller's own viewClasses / editClasses are used at DEFAULT (every caller today
    // passes them) but NOT at SMALL, where this set replaces them.
    getClasses() {

        if (this.props.size === FieldViewSize.SMALL) {
            return {
                view        : "ui5-txt-less-important-small ui5-field-input-hover-border h-30 p-l-8 p-r-8",
                edit        : "ui5-txt-less-important-small ui5-field-form-editable h-30 p-l-8 p-r-8",
                input       : this.props.inputClassName || "ui5-txt-less-important-small",
                emptyValue  : "ui5-txt-no-accent-small",
            }
        }

        return {
            view        : this.props.viewClasses,
            edit        : this.props.editClasses,
            input       : this.props.inputClassName || "ui5-txt-default",
            emptyValue  : "ui5-txt-no-accent-default",
        }
    }

    renderEditMode() {

        const sizeClasses = this.getClasses()

        const classes = Classes(sizeClasses.edit, this.props.className, {
            [sizeClasses.emptyValue]    : !this.value,
            'invalid-value'             : !this.isValueValid()
        })

        const showIcon = _.get(this.props.configOptions, 'showIcon', true) &&
                         _.get(this.props.options, 'showIcon', true)

        const ButtonComponent : any = _.get(this.props.field.components, 'ButtonComponent', false)

        // Patch for number / currency - tricky as it is in the string...
        let value = this.value
        if (this.props.isNumber) {
            if  (this.value === 0 || this.value==='0') {
                value = ''
            }
        }
        //

        return (
            <EditableInput ref                  = {(r:any)=>this.input = r}
                           className            = {classes}
                           inputClassName       = {sizeClasses.input}
                           value                = {value}
                           trimValue            = {_.isNil(this.props.field.trimValue)?true:this.props.field.trimValue}
                           icon                 = {
                               <React.Fragment>
                                   {showIcon && _.get(this.props.field.components, 'ValueIcon', false)}
                                   {_.get(this.props.field.components, 'ValuePrefix', false)}
                               </React.Fragment>
                           }
                           button               = {
                               <React.Fragment>
                                   {ButtonComponent && <ButtonComponent field={this.props.field} value={this.value}/>}
                               </React.Fragment>
                           }
                           placeholder          = {this.props.field.placeholder}
                           onBlur               = {this.onBlur}
                           onChange             = {this.onChange.bind(this)}
                           onEnter              = {this.props.onEnter}  // experimenta
                            // autoSaveChanges={this.props.autoSaveChanges} // experimental
                            focusOnMount={this.props.options?.autofocus}

                           onImmediateChange    = {this.onImmediateChange}/>
        )
    }

    renderViewMode() {
        let displayValue = this.props.field.getDisplayValue(this.value);
        const showIcon = _.get(this.props.configOptions, 'showIcon', true) &&
                              _.get(this.props.options, 'showIcon', true)

        const sizeClasses = this.getClasses()

        const classes = Classes(sizeClasses.view, this.props.className, {
            [sizeClasses.emptyValue]: !displayValue,
            'invalid-value': !this.isValueValid()
        })

        const viewValueClasses = Classes('view-value', this.props.inputClassName)

        if (!displayValue && this.props.field.placeholder) displayValue = this.props.field.placeholder

        const ButtonComponent : any = _.get(this.props.field.components, 'ButtonComponent', false)

        return (
            <div className={classes} onClick={this.onClick}>
                {showIcon && _.get(this.props.field.components, 'ValueIcon', false)}
                {_.get(this.props.field.components, 'ValuePrefix', false)}
                <div className={viewValueClasses}>{displayValue}</div>
                {ButtonComponent && <ButtonComponent field={this.props.field} value={displayValue}/>}
            </div>
        )
    }

    render() {
        switch (this.renderState) {
            case 'edit':
                return this.renderEditMode()

            case 'view':
            default:
                return this.renderViewMode()
        }
    }
}
